import {
  getLocalFormattedDate,
  graphqlDateFormat,
} from '../../utils/dateUtils';
import { CircleLevelPartial } from '../../_types/types.type';
import { LeaderboardStackView } from '../../store/zustand/useLeaderboardStore';
export const getDimensionValue = (ourDimensionTimeframe: string) => {
  if (ourDimensionTimeframe === 'Y') {
    return getLocalFormattedDate('YYYY');
  } else if (ourDimensionTimeframe === 'M') {
    return getLocalFormattedDate('YYYY-MM');
  } else if (ourDimensionTimeframe === 'D') {
    return getLocalFormattedDate('YYYY-MM-DD');
  } else if (ourDimensionTimeframe === 'W') {
    // The current week always starts on Monday
    const now = new Date();
    let weekStartDay = 0;
    //   @ts-ignore
    const globalWeekStartDay = global.appSettings.week_start_day;
    if (globalWeekStartDay !== undefined) {
      // week_start_day is the PYTHON week where 0=Monday, 6=Sunday
      weekStartDay = globalWeekStartDay;
      // Convert to the Javascript week where 0=Sunday, 6=Saturday
      weekStartDay += 1;
      if (weekStartDay > 6) {
        weekStartDay = 0;
      }
    }

    const curDayOfWeek = now.getUTCDay();
    const offset = (((curDayOfWeek - weekStartDay) % 7) + 7) % 7;
    const first = now.getDate() - offset;

    // if we're dealing with last week, subtract 7 from the first day and last day
    const firstDay = new Date(now.setDate(first)).toUTCString();
    return graphqlDateFormat(firstDay);
  }

  return '';
};

export const getWeekDimensionFormattedDate = (date?: string) => {
  if (!date) {
    date = new Date().toUTCString();
  }
  const [year, weekStr] = date.split('-W');
  const week = parseInt(weekStr);
  const formattedDate = new Date(parseInt(year), 0, 1 + (week - 1) * 7);
  return graphqlDateFormat(formattedDate.toUTCString());
};

export const createNewViewStask = (
  circleLevel: CircleLevelPartial
): LeaderboardStackView[] => {
  return [
    {
      viewID: '',
      dimensionType: 'circle',
      parentCircleID: '',
      parentCircleName: '',
      circleID: '',
      circleName: '',
      circleLevelID: circleLevel.id,
      circleLevelName: circleLevel.name,
    },
  ];
};
